import React, { useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { CheckboxProps, Form } from 'semantic-ui-react';
import { getLabel } from './util';

interface CheckboxFormFiled extends UseControllerProps {
  label?: string | JSX.Element;
  value?: any;
  control: any;
  checkboxValue?: any;
}

type CheckboxFormFiledProps = CheckboxFormFiled & CheckboxProps;

const Checkbox: React.FC<CheckboxFormFiledProps> = (props) => {
  const { field, fieldState } = useController(props);
  const { control, checkboxValue, label, rules, value, defaultValue, ...checkboxProps } = props;

  function notInViewport(element: any, offset = 0) {
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset >= window.innerHeight;
  }

  useEffect(() => {
    if (fieldState.error) {
      const element = document.getElementById(field.name);
      if (notInViewport(element)) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [fieldState]);

  function getValue(data: any) {
    if (checkboxValue) {
      if (data.checked) {
        return checkboxValue;
      }
      return props.defaultValue ? props.defaultValue : 0;
    }
    return data.checked;
  }

  return (
    <Form.Checkbox
      id={field.name + props.id}
      {...checkboxProps}
      error={Boolean(fieldState.error)}
      label={label}
      onBlur={field.onBlur}
      onChange={(e, data) => {
        field.onChange(getValue(data))
      }}
      checked={props.checked ? props.checked : checkboxValue && field.value ? checkboxValue === field.value : !!field.value}
    />
  );
};
export default Checkbox;
